import { Outlet } from 'react-router-dom'

export const AuthAreaLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}
